import { useState, useCallback } from "react";
import { getDocumentByStatusURL } from "../utils/ConstantsURL";

export const useFetchDocumentByStatus = (token) => {
  const [loading, setLoading] = useState(false);

  const fetchByStatus = useCallback(async (status) => {
    setLoading(true);
    try {
      const body = status !== undefined ? JSON.stringify({ flg: status }) : JSON.stringify({});
      const response = await fetch(getDocumentByStatusURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      });

      const data = await response.json();
      if (response.ok) {
        setLoading(false);
        return data;
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching documents by status:", error);
      return null;
    }
  }, [token]);

  return { loading, fetchByStatus };
};
